import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnVideoPlayerModule } from '@lib/player/video-player';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';
import { SnDialogModule } from '@lib/ui/dialog';

import { VerkadaDatetimePickerModalComponent, VerkadaPlayerComponent } from './components';
import { MapVerkadaService } from './map';
import { SnVerkadaService } from './services';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    SnIconModule,
    SnVideoPlayerModule,
    SnButtonModule,
    SnDialogModule,
  ],
  declarations: [VerkadaPlayerComponent, VerkadaDatetimePickerModalComponent],
  providers: [SnVerkadaService, MapVerkadaService],
  exports: [VerkadaPlayerComponent],
})
export class IntegrationsVerkadaModule {}
